var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImportType(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.668 4V9.33333C18.668 9.68696 18.8084 10.0261 19.0585 10.2761C19.3085 10.5262 19.6477 10.6667 20.0013 10.6667H25.3346M18.668 4H9.33464C8.62739 4 7.94911 4.28095 7.44902 4.78105C6.94892 5.28115 6.66797 5.95942 6.66797 6.66667V25.3333C6.66797 26.0406 6.94892 26.7189 7.44902 27.219C7.94911 27.719 8.62739 28 9.33464 28H22.668C23.3752 28 24.0535 27.719 24.5536 27.219C25.0537 26.7189 25.3346 26.0406 25.3346 25.3333V10.6667M18.668 4L25.3346 10.6667M16.0013 14.6667V22.6667M16.0013 14.6667L12.668 18M16.0013 14.6667L19.3346 18",
    stroke: "#5441D8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportType);
export default __webpack_public_path__ + "static/media/import-type.b87341926c745c6ebea2a3e6e87df032.svg";
export { ForwardRef as ReactComponent };